var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoRejectedS(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoRejectedS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.8130068,15.1421348 L11.7399731,0.592560939 C11.5043551,0.224846647 11.0813053,0 10.6249693,0 C10.1686333,0 9.74558347,0.224807591 9.50996551,0.592560939 L0.187014763,15.1421348 C-0.0554513508,15.5205505 -0.0626315353,15.9925449 0.168296479,16.3772877 C0.399224493,16.7620695 0.832401287,17 1.30197705,17 L18.698003,17 C19.1675788,17 19.6007556,16.7620305 19.8316836,16.3772877 C20.0626116,15.9925058 20.055473,15.5205505 19.8130068,15.1421348 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhotoRejectedS"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5068595,5 C11.0448158,5 11.5,5.29964005 11.5,5.83074154 C11.5,7.45134216 11.3068928,9.78020162 11.3068928,11.4008022 C11.3068928,11.8230073 10.8379063,12 10.5068595,12 C10.0655193,12 9.69306549,11.8229662 9.69306549,11.4008022 C9.69306549,9.78020162 9.5,7.45134216 9.5,5.83074154 C9.5,5.29964005 9.9413402,5 10.5068595,5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5065401,14 C9.93140819,14 9.5,13.5324696 9.5,13 C9.5,12.4545347 9.93136867,12 10.5065401,12 C11.042471,12 11.5,12.4545347 11.5,13 C11.5,13.5324696 11.042471,14 10.5065401,14 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoRejectedS);
export default __webpack_public_path__ + "static/media/icPhotoRejectedS.9a5ab5f2bffe5e90b21ca222b1be8d57.svg";
export { ForwardRef as ReactComponent };